import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles(() => ({
  mainDiv: {
    position: 'fixed',
    zIndex: '1300',
    right: '0px',
    bottom: '0px',
    top: '0px',
    left: '0px',
  },
  root: {
    zIndex: '-1',
    position: 'fixed',
    right: '0px',
    bottom: '0px',
    top: '0px',
    left: '0px',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    webkitTapHighlightColor: 'transparent',
    touchAction: 'none',
  },
  CircularProgress: {
    top: '50%',
    left: '50%',
    outline: 'none',
    position: 'absolute',
    color: '#fff',
  },
}));

function CircularIndeterminate({ showSpinner }) {
  const classes = useStyles();

  if (showSpinner) {
    return (
      <div className={classes.mainDiv}>
        <div className={classes.root}>
          <CircularProgress
            className={classes.CircularProgress}
            variant="indeterminate"
            disableShrink
          />
        </div>
      </div>
    );
  }
  return null;
}

export { CircularIndeterminate };
